import * as React from "react";
import * as qs from "querystring";

import { Header, Navigation, Footer } from "../../../shared";
import { AdministrationMenu } from "../../shared/menu/AdministrationMenu";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  TextField,
  Paper,
  Snackbar,
  SnackbarContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';


import "./ProductGrouping.scss";
import { TableProductGrouping } from "./TableProductGrouping";

import Rest from "src/services/Rest";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};

// tslint:disable-next-line:no-empty-interface
export interface IProductGroupingProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IProductGroupingState {
  alertMessage: string,
  alertOpened: boolean,
  alertType: string,

  error: string | null,
  limit: number,
  loading: boolean,
  offset: number,

  openDeleteConfirmationDialig: boolean,

  page: number,

  productGrouping: {
    group: number,
    priority: number,
    sku: string,
  },

  rowToDelete: any,
  rows?: any[],
}

export class ProductGrouping extends React.Component<IProductGroupingProps, IProductGroupingState> {

  constructor(props: IProductGroupingProps) {
    super(props);

    this.state = {
      alertMessage: '',
      alertOpened: false,
      alertType: 'success',

      error: null,
      limit: 10,
      loading: false,
      offset: 0,

      openDeleteConfirmationDialig: false,

      page: 0,

      productGrouping: {
        group: 0,
        priority: 1,
        sku: ''
      },

      rowToDelete: {},
      rows: []
    }

    this.clear = this.clear.bind(this);
    this.delete = this.delete.bind(this);
    this.save = this.save.bind(this);
    this.search = this.search.bind(this);
  }

  public componentDidMount() {
    this.search();
  }

  public render() {
 
    return (
      <div className="product-grouping-page">
        <Header title={"Agrupamento de Produtos"} name={"Administrativo"} link={"/dashboard"} />

        <Navigation name={"Agrupamento de Produtos"}
            linkDefault={"/administration/product-group-register"}
            link={"/dashboard"}
            linkTitle={"Produtos"}
            painel={3}
            icon={<ChevronRightIcon />}
        />
        
        <div className="product-grouping-body">
          <AdministrationMenu paramIcon={null} />

          <div className="wrapper">
            <Grid
              container={true}
              className="product-grouping-panel panel-grid"
              spacing={16}>

              <Grid item={true} xs={12} >
                <div>
                  <Paper className="analytical-panel">
                    <Dialog
                          open={this.state.openDeleteConfirmationDialig}
                          onClose={this.handleCloseDeleteConfirmationDialog}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                      >
                          <DialogTitle id="alert-dialog-title">{"Confirma a exclusão do item?"}</DialogTitle>
                          <DialogContent>
                              <DialogContentText id="alert-dialog-description">
                                  Após a exclusão de um item a operação não pode mais ser desfeita.
                              </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                              <Button onClick={this.handleCloseDeleteConfirmationDialog} color="primary">
                                  Cancelar
                              </Button>
                              <Button onClick={this.handleConfirmDeleteConfirmationDialog} color="primary" autoFocus={true}>
                                  Confirmar
                              </Button>
                          </DialogActions>
                      </Dialog>
                    <Grid container={true} direction="column" spacing={16}>
                      <Grid item={true}>
                        <Card>
                          <CardContent>

                            <Snackbar
                              anchorOrigin={{
                                horizontal: 'center',
                                vertical: 'center',
                              }}
                              open={this.state.alertOpened}
                              autoHideDuration={4000}
                              onClose={this.closeAlert}>
                              <SnackbarContent message={this.state.alertMessage} style={this.alertStyle()}/>
                            </Snackbar>
                              
                            <form>

                                <FormGroup row={true}>
                                    <TextField
                                        id="standard-sku-input"
                                        label="SKU"
                                        value={this.state.productGrouping.sku}
                                        onChange={this.handleChangeCadastro('sku')}
                                        style={this.textFieldStyle()}
                                        type="text"
                                        autoComplete="text"
                                        margin="normal"
                                        className="formTextField width-50"
                                        required={true}
                                    />

                                    <TextField
                                        id="standard-username-input"
                                        label="Grupo"
                                        value={this.state.productGrouping.group}
                                        onChange={this.handleChangeCadastro('group')}
                                        style={this.textFieldStyle()}
                                        type="number"
                                        autoComplete="number"
                                        margin="normal"
                                        className="formTextField width-20"
                                    />

                                    <FormControl required={true} className="width-20 margin-top-16" >
                                        <InputLabel id="priority-select-required-label">Prioridade</InputLabel>
                                        <Select
                                            id="priority-select-required"
                                            inputProps={{
                                              id: 1,
                                              name: 'priority',
                                            }}
                                            value={this.state.productGrouping.priority}
                                            onChange={this.handleChangeSelect}
                                        >
                                            <MenuItem value={2}>Baixa</MenuItem>
                                            <MenuItem value={1}>Média</MenuItem>
                                            <MenuItem value={0}>Alta</MenuItem>
                                        </Select>
                                    </FormControl>
                                </FormGroup>
                            </form>
                          </CardContent>
                          <CardActions>
                              <Button className="filter-dialog-clear" onClick={this.clear} >
                                  Limpar
                              </Button>
                              <Button className="filter-dialog-close" color="primary" onClick={this.search}>
                                  Pesquisar
                              </Button>
                              <Button className="filter-dialog-close" color="primary" onClick={this.save}>
                                  Salvar
                              </Button>
                          </CardActions>
                        </Card>
                        <Card>
                            <CardContent>
                                <TableProductGrouping 
                                  delete={this.handleClickOpenDeleteConfirmationDialog}
                                  error={this.state.error}
                                  loading={this.state.loading}
                                  rows={this.state.rows}
                                />
                            </CardContent>
                        </Card>
                      </Grid>
                    </Grid>
                  </Paper>
                        
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className="users-register-footer">
          <Footer />
        </div>
      </div>
    );
    }

    private search () {
      this.setState({loading : true});
      let endPoint = 'productGrouping';
      let queryParam = '';

      if(this.state.productGrouping) {
        if(this.state.productGrouping.sku && this.state.productGrouping.sku.length > 0) {
          queryParam = 'sku='+this.state.productGrouping.sku.trim();
        }

        if(this.state.productGrouping.group && this.state.productGrouping.group >= 0) {
          if(queryParam !== '') {
            queryParam += '&';
          }
          queryParam += 'group='+this.state.productGrouping.group;
        }

        if(this.state.productGrouping.priority != null && this.state.productGrouping.priority !== undefined 
          && this.state.productGrouping.priority >= 0) {
          if(queryParam !== '') {
            queryParam += '&';
          }
          queryParam += 'priority='+this.state.productGrouping.priority;
        }
      }

      if(queryParam !== '') {
        endPoint += '?'+queryParam;
      }

      Rest.GET(endPoint, null)
        .then(response => response.json())
        .then((result:any) => {
            if(result != null && result !== undefined) {
                this.setState({ loading: false, rows: result });
            } else {
              this.setState({ loading: false, rows: [] });
            }
        });
    }

    private save () {
      Rest.POSTComplete('productGrouping',qs.stringify(this.state.productGrouping), { 'Content-Type': 'application/x-www-form-urlencoded' })
        .then( (data:any)  => {
          if(data && data.data && data.data.errors != null && data.data.errors !== undefined && data.data.errors.length > 0) {
            this.openAlert(true, 'error', data.data.errors[0].message);
          } else {
            this.openAlert(true, 'success', 'Agrupamento inserido com sucesso.');
            setTimeout( this.search(), 3000 );
          }
        }).catch((err:any) => {
          let errorMessage = 'Falha ao salvar agrupamento.';
          if(err != null && err.response && err.response.data !=null && err.response.data.message && err.response.data.message !== "") {
            errorMessage = err.response.data.message;
          }
          this.openAlert(true, 'error', errorMessage);
        });
    }

    private delete (row:any) {
      Rest.DELETE('productGrouping', row.id)
        .then( data  => {
          if(data && data.data && data.data.errors != null && data.data.errors !== undefined && data.data.errors.length > 0) {
            this.openAlert(true, 'error', data.data.errors[0].message);
          } else {
            this.openAlert(true, 'success', 'Agrupamento deletado com sucesso.');
            setTimeout( this.search(), 3000 );
          }
        }).catch(err => {
          let errorMessage = 'Falha ao deletar agrupamento.';
          if(err != null && err !== undefined && err.message !=null && err.message !== undefined && err.message !== "") {
            errorMessage = err.message;
          }
          this.openAlert(true, 'error', errorMessage);
        });
    }

    private clear () {
      this.setState(
        {
          productGrouping : {
            group: 0,
            priority: 1,
            sku: ''
          }
        }
      );
    }

    private handleChangeCadastro = (param: any) => (event: React.FormEvent<HTMLInputElement>) => {
        const productGrouping = Object.assign({}, this.state.productGrouping);
        productGrouping[param] = event.currentTarget.value;
        if(param==='sku') {
          productGrouping.sku = productGrouping.sku.trim();
        }
        this.setState({ productGrouping });
    };

    private handleChangeSelect = (event: any) => {
        const productGrouping = Object.assign({}, this.state.productGrouping);
        productGrouping[event.target.name] = event.target.value;
        this.setState({ productGrouping });
    };

    private alertStyle = () => {
        return styles[this.state.alertType];
    }

    private textFieldStyle = () => {
        return Object.assign({}, styles.textField)
    }

    private openAlert(alertOpened: boolean, alertType: string, alertMessage: string) {
        this.setState({ alertType })
        this.setState({ alertMessage })
        this.setState({ alertOpened })
    }

    private closeAlert = (event: object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ alertOpened: false });
    }

    private handleClickOpenDeleteConfirmationDialog = (row : any) => {
        this.setState({ openDeleteConfirmationDialig: true, rowToDelete: row  });
    };

    private handleCloseDeleteConfirmationDialog = () => {
        this.setState({ openDeleteConfirmationDialig: false, rowToDelete: {} });
    };

    private handleConfirmDeleteConfirmationDialog = () => {
        this.delete(this.state.rowToDelete);
        this.setState({ openDeleteConfirmationDialig: false, rowToDelete: {} });
    };
    
}


// WEBPACK FOOTER //
// ./src/component/administration/registers/product-grouping/ProductGrouping.tsx